import {
  DefaultNodeOptions,
  Editor,
  Node,
  Widget,
} from '@sagold/react-json-editor';

import { Button } from '../../../components/buttons/Button';
import { GoogleFontIcon } from '../../../components/icons/GoogleFontIcon';
import { Popover } from '../../../components/popover/Popover';

export type ArrayItemOptions = Partial<DefaultNodeOptions>;

export type ArrayItemProps = {
  editor: Editor;
  /** child node */
  node: Node;
  size: number;
  disabled?: boolean;
  /** set to false to deactivate any array-item-controls */
  controls?: boolean;
  options?: ArrayItemOptions;
  /** set to true, if item can be deleted */
  optional?: boolean;
};

export function ArrayItem({
  editor,
  node,
  disabled,
  size,
  controls = true,
  optional,
  options = {},
}: ArrayItemProps) {
  return (
    <div data-type="array-item" className="rje-array-item">
      <Widget editor={editor} node={node} options={options} />
      {controls && (
        <div className="rje-array-item__menu">
          <Popover
            content={
              <ArrayItemActions
                editor={editor}
                node={node}
                size={size}
                optional={optional}
              />
            }
          >
            <Button
              variant="text"
              icon={<GoogleFontIcon name="more_vert" />}
              disabled={disabled}
            />
          </Popover>
        </div>
      )}
    </div>
  );
}

export type ArrayItemActionProps = {
  node: Node;
  editor: Editor;
  size: number;
  optional?: boolean;
};

export function ArrayItemActions({
  node,
  editor,
  size,
  optional,
}: ArrayItemActionProps) {
  return (
    <div className="rje-array-item__actions">
      <Button
        icon={<GoogleFontIcon name="delete" />}
        variant="text"
        disabled={optional === false}
        onClick={() => editor.removeValue(node.pointer)}
      />
      <Button
        icon={<GoogleFontIcon name="keyboard_arrow_up" />}
        variant="text"
        disabled={node.property === '0'}
        onClick={() =>
          editor.moveItem(node.pointer, Number.parseInt(node.property) - 1)
        }
      />
      <Button
        icon={<GoogleFontIcon name="keyboard_arrow_down" />}
        variant="text"
        disabled={node.property === `${size - 1}`}
        onClick={() =>
          editor.moveItem(node.pointer, Number.parseInt(node.property) + 1)
        }
      />
    </div>
  );
}
